import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { setupMuiLicense } from './providers/setupMuiLicense';
import { App } from './App';

setupMuiLicense();

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>
);
